import { get, isEmpty } from 'lodash'
import { createSelector } from 'reselect'

function camelToTitleCase(obj) {
  const newObj = {}

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase words
        .split(' ') // Split into words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' ') // Join words back together

      newObj[newKey] = obj[key]
    }
  }

  return newObj
}

export const getCurrentConfiguration = (state) => get(state, 'config', {})

export const getResourceList = (state) => camelToTitleCase(get(state, 'config.resourceList', {}))

export const getDeviceSubtype = (state) => get(state, 'config.deviceSubtype')

export const getControlledPrinterUuids = (state) => {
  return get(state, 'config.configuration.controlledPrinterUuids', [])
}

export const getIsPrintController = (state) => {
  return !isEmpty(getControlledPrinterUuids(state))
}

export const getSelectedMenusIds = (state) => state?.config?.configuration?.menuUuids ?? []

export const getDeviceAllowList = (state) => state?.config?.whitelist ?? ['https://www.google.com', 'https://fast.com']

export const getShouldWaitForRedirect = (state) => state?.config?.shouldWaitForRedirect ?? false

export const getBackbarMode = (state) => state?.config?.backbarMode ?? false

export const getReceiptSettings = (state) => state?.config?.receiptSettings ?? {}

/**
 * @returns { Object } Object displayScannableItems and barcodeScanningEnabled from config for barcode scanning settings
 */
export const getBarcodeScanningSettings = (state) => state?.config?.barcodeScanningSettings ?? {}

export const getBarcodeRestartState = (state) => state?.config?.resetBarcodeScanner ?? false

export const getKioskBarcodeScanningEnabled = (state) => {
  const kioskBarcodeScanningEnabled = state?.config?.kioskBarcodeScanningEnabled ?? false

  return kioskBarcodeScanningEnabled
}

/**
 * Checks for network availability based off of `useNetworkIsAvailable` ping for `blank.png`
 */
export const getNetworkAvailable = createSelector(getCurrentConfiguration, (state) => state?.networkAvailable ?? false)
